import React from 'react';
import BoxItem from 'reactor/components/Box';
import { makeStyles } from '@material-ui/core';
import ArrowDiagonalTop from './ArrowDiagonalTop';

const useStyles = makeStyles(theme => ({
    LinkStyle: {
        fontSize: '4rem',
        // lineHeight: '1',
        fontWeight: '900',
        color: '#B5C700',
        // textDecoration: 'underline',
        [theme.breakpoints.down('600')]: {
        },
        '& span': {
            lineHeight: '1.3',
            display: 'inline-block',
            textDecoration: 'underline',
            position: 'relative',
            transition: 'all 0.5s ease-in-out',
            '&:hover': {
                color: '#000'
            }
        }
    },
}));


export default function(props) {
    const classes = useStyles();

    return (
        <BoxItem display="flex" justifyContent="flex-end" className="more__link">
            <a href={props.href} className={classes.LinkStyle} target={props.out ? "_blank" : ""} >
                <span dangerouslySetInnerHTML={{__html: props.linkname}}></span>
                <ArrowDiagonalTop color="#B5C700" />
            </a>
        </BoxItem>
    )
}
